export default __webpack_public_path__ + "static/media/emptyIcon.679f63e5.svg";